/* eslint-disable max-len */
export const LIMITS = [9, 18, 27, 36, 45]
export const EXTRA_DATE_FORMAT = 'dd/MM/yyyy';
export const EXTRA_DATE_FORMAT_WITH_TIME = 'dd/MM/yyyy hh:mm:ss';

export const PARAMS = {
  LIMIT: LIMITS[0],
  OFFSET: 0
}

export const ApiEndpoint = process.env.REACT_APP_API_BASE_URL

export const imagesFileFormats = [
  'image/png', 'image/jpeg', 'image/jpg', 'image/webp', 'image/gif', 'image/bmp', 'image/tiff', 'image/svg+xml', // Image MIME types
]

export const videoFileFormats = [
  'video/mp4', 'video/x-msvideo', 'video/x-matroska', 'video/quicktime', 'video/x-ms-wmv', 'video/x-flv', 'video/webm', 'video/3gpp', 'video/mpeg', 'video/ogg', 'video/hevc', 'video/h264' // Video MIME types
]

export const videoFileShortFormats = [
  'mp4', 'avi', 'mkv', 'mov', 'wmv', 'flv', 'webm', '3gp', 'mpeg', 'ogg', 'hevc', 'h264'
];

/* eslint-disable max-len */
export const extendedFileFormats = [
  ...imagesFileFormats,
  ...videoFileFormats
];
